import { DiagnosisStatus } from '@common/models/Enums';
import classNames from 'classnames';
import React from 'react';

type StatusPillProps = {
  diagnosisStatusId: number;
};

export const DiagnosisStatusPill = ({ diagnosisStatusId }: StatusPillProps) => {
  const getDiagnosisStatusPill = (diagnosisStatusId: number) => {
    switch (diagnosisStatusId) {
      case DiagnosisStatus.Open:
        return 'danger-pill';
      case DiagnosisStatus.Resolved:
        return 'green-pill';
      default:
        return 'blue-pill';
    }
  };
  return (
    <span
      className={classNames(
        'd-inline-block status-pill text-uppercase',
        getDiagnosisStatusPill(diagnosisStatusId),
      )}
    >
      {DiagnosisStatus[diagnosisStatusId]}
    </span>
  );
};
